export const settings = {
    "title": "Fedespedi e-Library",
    "apiUrl": "https://api-elibrary.fedespedi.it/api",
    "ckdPath": "https://api-elibrary.fedespedi.it/",
    "config": {
        "limit": 100,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    }
}